import { render } from "./CryptoAccount.vue?vue&type=template&id=32b57f88"
import script from "./CryptoAccount.vue?vue&type=script&lang=js"
export * from "./CryptoAccount.vue?vue&type=script&lang=js"

import "./CryptoAccount.vue?vue&type=style&index=0&id=32b57f88&lang=css"
import "./CryptoAccount.vue?vue&type=style&index=1&id=32b57f88&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__